import { contactContent } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
              {contactContent.title}
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600">
              {contactContent.subtitle}
            </p>
          </div>

          <div className="bg-background-50 rounded-lg border border-background-200/70 p-6 md:p-10">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed text-center">
              {contactContent.desc}
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-8">
              <div className="flex items-center gap-4 p-4 bg-background-100 rounded-lg">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700 flex-shrink-0">
                  <i className="ri-mail-line text-lg"></i>
                </div>
                <div className="min-w-0">
                  <div className="text-xs text-foreground-400">投稿邮箱</div>
                  <div className="text-sm font-medium text-foreground-900 truncate">{contactContent.email}</div>
                </div>
              </div>

              <div className="flex items-center gap-4 p-4 bg-background-100 rounded-lg">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700 flex-shrink-0">
                  <i className="ri-wechat-line text-lg"></i>
                </div>
                <div className="min-w-0">
                  <div className="text-xs text-foreground-400">微信联系</div>
                  <div className="text-sm font-medium text-foreground-900 truncate">{contactContent.wechat}</div>
                </div>
              </div>
            </div>

            <div className="mt-6 p-4 bg-accent-50 rounded-lg border border-accent-200/70">
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-information-line text-accent-600 text-lg"></i>
                </div>
                <p className="text-sm text-accent-800 leading-relaxed">
                  {contactContent.hint}
                </p>
              </div>
            </div>

            <div className="mt-6 text-center">
              <a
                href={`mailto:${contactContent.email}`}
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-full text-sm transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-send-plane-line text-lg"></i>
                立即投稿
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}